import React, { useCallback, useState } from 'react';
import { IABTestsContext } from './models';
import { INITIAL_TESTS_DATA, INITIAL_CONTEXT_STATE } from './constants';

export const ABTestsContext = React.createContext<IABTestsContext>(INITIAL_CONTEXT_STATE);

export const ABTestsContextProvider: React.FC<React.ReactNode> = ({ children }) => {
  const [tests, _setTests] = useState(INITIAL_TESTS_DATA);

  const get = useCallback(({ name, kind }) => tests[name][kind], [tests]);
  const set = useCallback(
    ({ name, kind, content }) => _setTests((prev) => ({ ...prev, [name]: { ...prev[name], [kind]: { ...prev[name][kind], ...content } } })),
    []
  );

  const setTestData = useCallback(({ testName, data }) => set({ name: testName, kind: 'data', content: data }), [set]);
  const getTestData = useCallback(({ testName }) => get({ name: testName, kind: 'data' }), [get]);
  const getTestProperties = useCallback(({ testName }) => get({ name: testName, kind: 'properties' }), [get]);
  const setTestProperties = useCallback(({ testName, properties }) => set({ name: testName, kind: 'properties', content: properties }), [set]);

  // Return tests properties in one flat object.
  const getFlatTestsProperties = useCallback(() => Object.values(tests).reduce((acc, test) => ({ ...acc, ...test.properties }), {}), [tests]);

  return (
    <ABTestsContext.Provider
      value={{
        data: {
          get: getTestData,
          set: setTestData,
        },
        properties: {
          get: getTestProperties,
          set: setTestProperties,
          getAllFlat: getFlatTestsProperties,
        },
      }}>
      {children}
    </ABTestsContext.Provider>
  );
};
